class Main {
    lockScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft =
            window.pageXOffset || document.documentElement.scrollLeft;

        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
    }

    unlockScroll() {
        window.onscroll = function () {};
    }
}

export default Main;
